import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useLoader } from '../../../Cruds/Searches/components/OverallContext';
import { OverallProvider } from '../../../Cruds/Searches/components/OverallContext';

const RouteChangeLoader = () => {
  const location = useLocation();
  const { setLoading } = useLoader();
  const firstLoad = useRef(true);

  useEffect(() => {
    if (firstLoad.current) {
      firstLoad.current = false;
      return;
    }

    setLoading(true);
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 600); // simulate transition delay

    return () => clearTimeout(timeout);
  }, [location]);

  return null;
};

export default RouteChangeLoader;
